export function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isString(str) {
    return typeof str === 'string';
}



// WEBPACK FOOTER //
// ./src/util/string.js